import state from '@/store/modules/bs_myp/state'
import actions from '@/store/modules/bs_myp/actions'
import mutations from '@/store/modules/bs_myp/mutations'
import getters from '@/store/modules/bs_myp/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
